import React from "react";
import MenuBar from "../../../components/nav/Menubar";
import { MainContainer } from "../../../styles/styles";
import KeyBenefits from "../../../features/landing/KeyBenefitsSection";
import FooterSection from "../../../features/landing/Footer";
import ProblemSolutionSection from "../../../features/landing/ProblemSolutionSection";
import ProductSection from "../../../features/landing/ProductSection";
import HeroSection from "../../../features/landing/HeroSection";

const LandingPage: React.FC = () => {

  return (
    <>
      <MenuBar />
      <MainContainer>
        <HeroSection />
        <ProblemSolutionSection />
        <ProductSection />
        <KeyBenefits />
        <FooterSection />
      </MainContainer>
    </>
  );
};

export default LandingPage;
